/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leveling_Perm_View_Guild_Insights_HintInputs */



/**
* | output |
* | --- |
* | "Allows members to view Server Insights, which shows data on community growth, engagement and more. This will allow them to see certain data about channel act..." |
*
* @param {Leveling_Perm_View_Guild_Insights_HintInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const leveling_perm_view_guild_insights_hint = /** @type {((inputs?: Leveling_Perm_View_Guild_Insights_HintInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leveling_Perm_View_Guild_Insights_HintInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Позволяет участникам открывать аналитику сервера: данные о росте сообщества, вовлечённости и не только. В ней видна и часть данных об активности каналов, даже тех, к которым у участника нет доступа.")
	return /** @type {LocalizedString} */ ("Allows members to view Server Insights, which shows data on community growth, engagement and more. This will allow them to see certain data about channel activity, even for channels they cannot access.")
});